// extracted by mini-css-extract-plugin
export default {"setMain":"Contact_setMain__zjAOU","setbox":"Contact_setbox__dNS5O","setimg":"Contact_setimg__bvl-a","address":"Contact_address__GyzUa","plaza":"Contact_plaza__lOWBP"};